import * as Constants from '../constants/organization';

export const getOrganizations = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_ORGANIZATIONS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/organizations/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_ORGANIZATIONS_SUCCESS, payload: res.data.organizations });
        resolve(res.data.organizations);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_ORGANIZATIONS_FAILED, payload: error });
        reject(error);
      });
  });

export const createOrganization = ($http, ENV, organizationInfo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_ORGANIZATION_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/1.0/organizations/`,
      data: organizationInfo,
    })
      .then((res) => {
        dispatch({ type: Constants.CREATE_ORGANIZATION_SUCCESS, payload: res.data.organization });
        resolve(res.data.organization);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_ORGANIZATION_FAILED, payload: error });
        reject(error);
      });
  });

export const getOrganization = ($http, ENV, organizationId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_ORGANIZATION_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/organizations/${organizationId}/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_ORGANIZATION_SUCCESS, payload: res.data.organization });
        resolve(res.data.organization);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_ORGANIZATION_FAILED, payload: error });
        reject(error);
      });
  });

export const updateOrganization = ($http, ENV, organizationId, organizationInfo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_ORGANIZATION_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/1.0/organizations/${organizationId}/`,
      data: organizationInfo,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_ORGANIZATION_SUCCESS, payload: res.data.organization });
        resolve(res.data.organization);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_ORGANIZATION_FAILED, payload: error });
        reject(error);
      });
  });

export const searchOrganization = ($http, ENV, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.SEARCH_ORGANIZATION_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/organizations/`,
      params,
    })
      .then((res) => {
        dispatch({ type: Constants.SEARCH_ORGANIZATION_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.SEARCH_ORGANIZATION_FAILED, payload: error });
        reject(error);
      });
  });

export const searchOrganizationByUrl = ($http, url) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.SEARCH_ORGANIZATION_BY_URL_REQUEST });

    $http({
      method: 'GET',
      url,
    })
      .then((res) => {
        dispatch({ type: Constants.SEARCH_ORGANIZATION_BY_URL_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.SEARCH_ORGANIZATION_BY_URL_FAILED, payload: error });
        reject(error);
      });
  });

export const getOrganizationStates = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_ORGANIZATION_STATES_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/states/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_ORGANIZATION_STATES_SUCCESS, payload: res.data.states });
        resolve(res.data.states);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_ORGANIZATION_STATES_FAILED, payload: error });
        reject(error);
      });
  });

export const getGeoCode = ($http, ENV, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_GEO_CODE_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/geocoding/`,
      params,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_GEO_CODE_SUCCESS, payload: res.data.geocoding });
        resolve(res.data.geocoding);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_GEO_CODE_FAILED, payload: error });
        reject(error);
      });
  });

export const getOrganizationStatistics = ({ $http, ENV, organizationId }) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_ORGANIZATION_STATISTICS_REQUEST });
    $http({
      method: 'GET',
      url: `${ENV.apiEndpoint}/2.0/organizations/${organizationId}/statistics/`,
    })
      .then((res) => {
        const statistics = res.data['organization-statistics'];
        dispatch({
          type: Constants.GET_ORGANIZATION_STATISTICS_SUCCESS,
          payload: statistics,
        });
        resolve(statistics);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_ORGANIZATION_STATISTICS_FAILED, payload: error });
        reject(error);
      });
  });

export const clearOrganization = () => (dispatch) =>
  dispatch({ type: Constants.CLEAR_ORGANIZATION });
